/**
 * CDS Wishlist — Système de favoris localStorage
 */
(function(){
  'use strict';

  var STORAGE_KEY = 'cds_wishlist';

  function getAll(){
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch(e){ return []; }
  }

  function save(list){
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch(e){}
  }

  function has(handle){
    return getAll().indexOf(handle) !== -1;
  }

  function toggle(handle){
    var list = getAll();
    var idx = list.indexOf(handle);
    if(idx === -1){ list.push(handle); }
    else { list.splice(idx, 1); }
    save(list);
    updateUI();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handle: handle, count: list.length } }));
    return idx === -1; /* true = added, false = removed */
  }

  function count(){
    return getAll().length;
  }

  function updateUI(){
    var list = getAll();
    var c = list.length;

    /* Update all heart buttons */
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn){
      var handle = btn.getAttribute('data-product-handle');
      if(list.indexOf(handle) !== -1){
        btn.classList.add('is-wishlisted');
        btn.setAttribute('aria-label', 'Retirer des favoris');
      } else {
        btn.classList.remove('is-wishlisted');
        btn.setAttribute('aria-label', 'Ajouter aux favoris');
      }
    });

    /* Update all count badges */
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el){
      el.textContent = c;
      var bubble = el.closest('.wishlist-bubble');
      if(bubble){
        if(c > 0) bubble.style.display = '';
        else bubble.style.display = 'none';
      }
    });
  }

  /* Event delegation — handle clicks on wishlist hearts */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-wishlist-toggle]');
    if(!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    if(!handle) return;
    var added = toggle(handle);
    /* Animate */
    btn.classList.add('wishlist-pop');
    setTimeout(function(){ btn.classList.remove('wishlist-pop'); }, 300);
  }, true);

  /* Init on DOM ready */
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', updateUI);
  } else {
    updateUI();
  }

  /* Public API */
  window.CdsWishlist = {
    toggle: toggle,
    has: has,
    getAll: getAll,
    count: count,
    updateUI: updateUI
  };
})();
